import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/shared/gaurd/auth.guard';
import { AssignmentComponent } from './assignment/assignment.component';
import { CallbackComponent } from './callback/callback.component';
import { ConnectionStatusComponent } from './connection-status/connection-status.component';
import { ShopifyConnectionStatusComponent } from './shopify-connection/shopify-connection.component';
import { ShopifyCallbackComponent } from './shopify-callback/shopify-callback.component';
import { CoreComponent } from './core/core.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { IntegrationStatusComponent } from './integration-status/integration-status.component';
import { OrdersNewComponent } from './orders-new/orders-new.component';
import { OrdersComponent } from './orders/orders.component';
import { StatusComponent } from './status/status.component';
import { StockComponent } from './stock/stock.component';
import { WarehouseComponent } from './warehouse/warehouse.component';
import { ShippedComponent } from './shipped/shipped.component';
import { ReturnComponent } from './return/return.component';
import { SyncDashboardComponent } from './sync-dashboard/sync-dashboard.component';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { title: 'Dashboard' },
  },
  {
    path: 'stock',
    component: StockComponent,
    canActivate: [AuthGuard],
    data: { title: 'Stock' },
  },
  {
    path: 'assignment',
    component: AssignmentComponent,
    canActivate: [AuthGuard],
    data: { title: 'Assignment' },
  },
  {
    path: 'status',
    component: StatusComponent,
    canActivate: [AuthGuard],
    data: { title: 'Status' },
  },
  {
    path: 'orders-old',
    component: OrdersComponent,
    canActivate: [AuthGuard],
    data: { title: 'Orders' },
  },
  {
    path: 'orders',
    component: OrdersNewComponent,
    canActivate: [AuthGuard],
    data: { title: 'Orders' },
  },
  {
    path: 'warehouse',
    component: WarehouseComponent,
    canActivate: [AuthGuard],
    data: { title: 'Warehouse' },
  },
  {
    path: 'logs',
    component: IntegrationStatusComponent,
    canActivate: [AuthGuard],
    data: { title: 'Integration' },
  },
  {
    path: 'sync-dashboard',
    component: SyncDashboardComponent,
    canActivate: [AuthGuard],
    data: { title: 'Sync Dashboard' },
  },
  {
    path: 'connection',
    component: ConnectionStatusComponent,
    canActivate: [AuthGuard],
    data: { title: 'Connection' },
  },
  {
    path: 'callback',
    component: CallbackComponent,
    canActivate: [AuthGuard],
    data: { title: 'callback' },
  },
  {
    path: 'shopify-connection',
    component: ShopifyConnectionStatusComponent,
    canActivate: [AuthGuard],
    data: { title: 'Shopify Connection' },
  },
  {
    path: 'shopify-callback',
    component: ShopifyCallbackComponent,
    canActivate: [AuthGuard],
    data: { title: 'Shopify Callback' },
  },
  {
    path: 'shipped',
    component: ShippedComponent,
    canActivate: [AuthGuard],
    data: { title: 'Shipped' },
  },
  {
    path: 'return',
    component: ReturnComponent,
    canActivate: [AuthGuard],
    data: { title: 'Return' },
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BadeloftPagesRoutingModule {}
